import React, { useState } from 'react';
import './MicropythonFirmwares.scss';
import classnames from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import { MicropythonFirmwaresProps } from '../../entities/ContentProps';
import { DOWNLOAD_LINK } from '../../utils/constants';

export default function MicropythonFirmwaresMobile(props: MicropythonFirmwaresProps): React.ReactElement {
  const { firmwareData } = props;
  const [selectedBoard, setSelectedBoard] = useState(0);

  return (
    <div className="firmwares-mobile">
      <div className="firmwares-mobile__content">
        <Swiper
          spaceBetween={0}
          initialSlide={0}
          slidesPerView={2}
          grabCursor={true}
          watchOverflow={true}
          centeredSlides={true}
          direction={'horizontal'}
          loop={false}
          className={'firmwares-mobile__swiper-header'}
        >
          {firmwareData.map((typeBoard, i: number) => {
            return (
              <SwiperSlide key={typeBoard.displayname}>
                <div
                  className={classnames('firmwares-mobile__box', {
                    'firmwares-mobile__box--selected': selectedBoard === i,
                  })}
                  onClick={() => setSelectedBoard(i)}
                >
                  <h5>{typeBoard.displayname}</h5>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
        <div className="firmwares-mobile__columns">
          {firmwareData.map((typeBoard, i: number) => {
            return selectedBoard === i ? (
              <div className="firmwares-mobile__categories" key={selectedBoard}>
                {typeBoard.releases.map((firmware) => {
                  return (
                    <SwiperSlide key={selectedBoard + ' ' + firmware.name}>
                      <a
                        key={selectedBoard + ' ' + firmware.name + ' ' + firmware.url}
                        href={DOWNLOAD_LINK + firmware.url}
                        className="firmwares-mobile__item"
                        download
                      >
                        {firmware.type} {firmware.name}
                      </a>
                    </SwiperSlide>
                  );
                })}
              </div>
            ) : null;
          })}
        </div>
      </div>
    </div>
  );
}
